<div class="line"></div>
<div class="ornament"></div>
<div class="line"></div>
